import React from 'react';
import { FaUserMd, FaTooth, FaBaby, FaHeartbeat, FaBone } from 'react-icons/fa';
import { GiFootTrip, GiBackPain, GiMuscleUp } from 'react-icons/gi';
import { MdLocalHospital, MdPsychology } from 'react-icons/md';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBandAid, faEye } from '@fortawesome/free-solid-svg-icons';
import './TopSpecialties.css';


const EyeIcon = () => <FontAwesomeIcon icon={faEye} />;
const BandAid = () => <FontAwesomeIcon icon={faBandAid} />
const specialties = [
    { name: 'Primary Care', icon: <FaUserMd /> },
    { name: 'Dentist', icon: <FaTooth /> },
    { name: 'OB-GYN', icon: <MdLocalHospital /> },
    { name: 'Dermatologist', icon: <BandAid /> },
    { name: 'Podiatrist', icon: <GiFootTrip /> },
    { name: 'Psychiatrist', icon: <MdPsychology /> },
    { name: 'Orthopedic Surgeon', icon: <FaBone /> },
    { name: 'Physical Therapist', icon: <GiMuscleUp /> },
    { name: 'Chiropractor', icon: < GiBackPain /> },
    { name: 'Pediatrician', icon: <FaBaby /> },
    { name: 'Eye Doctor', icon:  <EyeIcon /> }, // Replace with an eye icon if needed
    { name: 'Cardiologist', icon: <FaHeartbeat /> }
];

const TopSpecialties = () => {
    return (
        <section className="specialties-section">
            <div className="container">
                <h4 className="specialties-subheading">HEALTHCARE SPECIALTIES</h4>
                <h2 className="specialties-heading">Top Specialties</h2>
                <div className="specialties-grid">
                    {specialties.map((specialty, index) => (
                        <div key={index} className="specialty-card">
                            <div className="specialty-icon">{specialty.icon}</div>
                            <p className="specialty-name">{specialty.name}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TopSpecialties;
